app.controller("EditGradeComponentController", [
    "$scope", "GradeTemplate", "$uibModalInstance", "params", "Season",
    function ($scope, GradeTemplate, $uibModalInstance, params, Season) {
        var component = params.component;
        $scope.relative = component.relative;
        $scope.absolute = component.absolute;
        $scope.type = component.type;
        $scope.replace = component.replace ? component.replace._id : null;
        $scope.name = component.name;
        $scope.right = component.right;
        $scope.index = component.index;
        $scope.minValue = component.minValue;
        $scope.closesSelection = component.closesSelection;
        $scope.mustComplete = component.mustComplete;
        $scope.startWeekNumber= component.startWeekNumber ? Number(component.startWeekNumber) : null;
        $scope.durationWeeks= component.durationWeeks ? Number(component.durationWeeks) : null;

        var types = [
            {name: "ქულა", value: "grade"},
            {name: "ჯგუფი", value: "group"}
        ];

        $scope.items = params.items;

        $scope.types = [types[0]];
        if (params.component.parent === null) {
            $scope.types.push(types[1]);
        }
        // console.log($scope.items);

        function generateWeekOptions() {
          Season.getCurrent()
            .then(function (season) {
              if (!season) {
                $scope.startWeekOptions = [];
                $scope.durationOptions = [];
                return;
              }

              $scope.startWeekOptions = season.weeks.map(function (week) {
                return Number(week.weekNumber);
              });

              $scope.onStartWeekChange();
            });
        }

        $scope.onStartWeekChange = function () {
          if (!$scope.startWeekNumber) {
            $scope.durationOptions = $scope.startWeekOptions.concat([]);
            return;
          }

          var maxDuration = $scope.startWeekOptions.length - $scope.startWeekNumber + 1; //at least 1 week duration

          $scope.durationOptions = [];

          for (var i = 1; i <= maxDuration; i++) {
            $scope.durationOptions.push(i);
          }
        };

        generateWeekOptions();

        $scope.update = function () {
            var replace = $scope.replace === "" ? null : $scope.replace;
            GradeTemplate.editComponent({
                _id: component._id,
                replace: replace,
                name: $scope.name,
                type: $scope.type,
                relative: $scope.relative,
                absolute: $scope.absolute,
                closesSelection: $scope.closesSelection,
                mustComplete: $scope.mustComplete,
                minValue: $scope.minValue,
                right: $scope.right,
                index: $scope.index,
                startWeekNumber: $scope.startWeekNumber,
                durationWeeks: $scope.durationWeeks
            }).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
